import { Injectable, inject } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { from } from 'rxjs'
import { map, switchMap } from 'rxjs/operators'
import { PricingTermsService } from 'src/pages/admin/settings/admin-setting-payments/pricing-terms/pricing-terms.service'
import { ToasterService } from 'src/shared/toaster/toaster.service'
import { catchAndLog } from 'src/shared/utils/catch-and-log'
import { loadPricingTerms, loadPricingTermsFailure, loadPricingTermsSuccess } from './pricing-term.actions'

@Injectable()
export class PricingTermEffects {
  private actions$ = inject(Actions)
  private PricingTerms = inject(PricingTermsService)
  private toaster = inject(ToasterService)


  loadPricingTerms$ = createEffect(() => this.actions$.pipe(
    ofType(loadPricingTerms),
    switchMap(action =>
      from(this.PricingTerms.getPricingTerms()).pipe(
        map(pricingTerms => loadPricingTermsSuccess({
          tableKey: action.tableKey,
          pricingTerms: pricingTerms,
        })),
        catchAndLog(this.toaster, 'Unable to fetch pricingTerms', loadPricingTermsFailure
      )))))
}
